// extracted by mini-css-extract-plugin
export default {"inputBlock":"InputWindow_inputBlock__IyJ9n","inputCont":"InputWindow_inputCont__a9lCT","input":"InputWindow_input__CZMqc","close":"InputWindow_close__5zURB"};